import { AsyncPipe } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RefundReason } from '@fitness-force/enum';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'refund-reason',
  template: `
    @if (
      {
        row: columnData | async,
        adata: additionData | async,
      };
      as $
    ) {
      @if ($.row && $.adata.fetch_key) {
        <span>{{ getMode($.row[$.adata.fetch_key], $.row) }}</span>
      } @else {
        --
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [AsyncPipe],
})
export class RefundReasonComponent {
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);

  getMode(value: number, data: any) {
    if (!value || value == 0 || value == -1) return '-';
    else if (Object.keys(value).length == 0) {
      return '-';
    } else {
      return RefundReason[value];
    }
  }
}
